import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaisyAvatarComponent, DaisyTooltipDirective } from '@pathfinder/daisy-controls/ui';
import { RouterLinkSafeUrlPipe, TimeAgoPipe } from '@lib/shared/util';
import { Router, RouterModule } from '@angular/router';
import { NotificationService } from '@lib/notification/data-access';
import { NotificationModel, NotificationGroupModel } from '@lib/notification/models';
import { ToastMessageService } from '@lib/shared/data-access';
import { IncidentService } from '@lib/incident/data-access';
import { AuthService } from '@lib/auth/data-access';

@Component({
  selector:
    'lib-notification-feature-incident-assignment-notification-template',
  standalone: true,
  imports: [
    RouterLinkSafeUrlPipe,
    CommonModule,
    RouterModule,
    TimeAgoPipe,
    DaisyAvatarComponent,
    DaisyTooltipDirective,
  ],
  templateUrl:
    './notification-incident-assignment-notification-template.component.html',
  styleUrl:
    './notification-incident-assignment-notification-template.component.scss',
})
export class NotificationIncidentAssignmentNotificationTemplateComponent {
  // inject
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private toastMessageService = inject(ToastMessageService);
  private incidentService = inject(IncidentService);
  public authService = inject(AuthService);
  
  // public
  public isExpanded = false;
  @Input() groupedNotification!: NotificationGroupModel;

  // accessibility only --start--
  public onHandleNotificationsKeyDown(notifications: NotificationModel[] | NotificationModel, event: KeyboardEvent) {
    if (event.key === 'Enter') {
      // Check if notifications is a single object and wrap it in an array if necessary
      const notificationsArray = Array.isArray(notifications) ? notifications : [notifications];
      this.onNavigateToAssignmentClick(notificationsArray[0]);  // Navigate using the parent group notification or individual notification
      this.onMarkNotificationsReadStatusesClick(notificationsArray, true);
    }
  }
  // accessibility only --end--

  public onNavigateToAssignmentClick(notification: NotificationModel) {
    this.notificationService.hideNotificationSidebar();
    this.incidentService.setIsComingFromOutsideModule(true, 'assignments');
    this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/incidents/${notification.relatedModule?.moduleId}/assignments`);
  }

  public onHyperLinkClick(notification: NotificationModel, $event: MouseEvent) {
    if ($event) $event.stopPropagation();

    this.onMarkNotificationsReadStatusesClick(notification, true, $event);
  }

  public onMarkNotificationsReadStatusesClick(notifications: NotificationModel[] | NotificationModel, markAsRead: boolean, event?: MouseEvent) {
    if (event) event.stopPropagation();

    // Ensure notifications is always treated as an array
    const notificationsArray = Array.isArray(notifications) ? notifications : [notifications];

    // Filter out any notifications without an id and update their read status
    const updatedNotifications = notificationsArray.filter(notification => notification.id !== undefined);

    updatedNotifications.forEach(notification => {
      notification.isRead = markAsRead;
    });

    if (updatedNotifications.length > 0) {
      this.notificationService.updateNotificationsStatus(updatedNotifications).subscribe({
        error: () => this.toastMessageService.showError("Error updating notification status.")
      });
    }
  }

  public toggleExpansion() {
    this.isExpanded = !this.isExpanded;
  }
}
